import React from "react";
import ReactDOM from "react-dom/client";
import "./assets/css/goodgames.min.css";
import "./assets/css/custom.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import App from "./App";

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
